import {Link, Page} from './index';

export enum AssetDataKey {
  ASSET_KEY = 'assetKey',
  AGENT_KEY = 'agentKey',
  HOSTNAME = 'hostName',
  IP = 'ip',
  RULE_COMPLIANCE = 'policyRuleCompliance',
  POLICY_RESULT_STATUS = 'policyResultStatus',
  STATUS = 'status',
  LAST_AGENT_POLICY_ASSESSMENT_TIME = 'lastAgentPolicyAssessmentTime',
  LAST_SCAN_TIME = 'lastScanTime',
  OS_DESCRIPTION = 'osDescription',
  IS_OVERRIDEN = 'overridden',
}

export enum AssetStatuses {
  PASS = 'PASS',
  FAIL = 'FAIL',
  NOT_APPLICABLE = 'N/A',
  ERROR = 'ERROR',
}

export type Asset = {
  assetKey: string;
  cntPolicies: number;
  cntPolicyFindingsPassing: number;
  cntPolicyFindingsTotal: number;
  hostName: string;
  ip: string;
  lastScanTime: number;
  links: any[];
  osDescription: string;
  policyRuleCompliance: number;
  lastAgentPolicyAssessmentTime: number;
};

export type Proof = {
  lastAssessedTime: string;
  proof: string;
  ruleNaturalId: string;
};

export type AssetsResponse = {
  links: Link[];
  page: Page;
  resources: Asset[];
};

export enum AssetDetailsTabViews {
  RULES = 'rules',
  OVERRIDES = 'overrides',
}
